import { useEffect } from 'react';

const TINYMCE_AUX_SELECTOR = '.tox-tinymce-aux';

const SAFE_OUTSIDE_SELECTORS = ['[data-sonner-toast]', TINYMCE_AUX_SELECTOR];

export const isSafeOutsideTarget = (target: EventTarget | null) => {
  if (!(target instanceof Element)) {
    return false;
  }

  return SAFE_OUTSIDE_SELECTORS.some((selector) => target.closest(selector));
};

const isTinyMceAuxTarget = (target: EventTarget | null) =>
  target instanceof Element && Boolean(target.closest(TINYMCE_AUX_SELECTOR));

const unhideTinyMceAux = () => {
  document
    .querySelectorAll(`${TINYMCE_AUX_SELECTOR}[aria-hidden="true"]`)
    .forEach((element) => {
      element.removeAttribute('aria-hidden');
      element.removeAttribute('data-aria-hidden');
    });
};

export const useTinyMceDialogLayer = () => {
  useEffect(() => {
    const stopFocusTrap = (event: FocusEvent) => {
      if (
        isTinyMceAuxTarget(event.target) ||
        isTinyMceAuxTarget(event.relatedTarget)
      ) {
        event.stopImmediatePropagation();
      }
    };

    document.addEventListener('focusin', stopFocusTrap, true);
    document.addEventListener('focusout', stopFocusTrap, true);

    unhideTinyMceAux();

    const observer = new MutationObserver(unhideTinyMceAux);

    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['aria-hidden'],
    });

    return () => {
      document.removeEventListener('focusin', stopFocusTrap, true);
      document.removeEventListener('focusout', stopFocusTrap, true);
      observer.disconnect();
    };
  }, []);
};
